import React, { useEffect, useReducer, useState } from "react"
import { obterEstrategias } from "../../../services/estrategiasFornecedor"
import useLoadingStore from "../../../stores/LoadingStore"
import { Loading } from "../../RegistradorDePedidos"
import { EstrategiasFornecedorInicial } from "../models/estrategiasFornecedorModel"
import { EstrategiasFornecedorActionsTypes } from "./estrategiasFornecedorActions"
import { EstrategiasFornecedorContext } from "./EstrategiasFornecedorContext"
import { estrategiasFornecedorReducer } from "./estrategiasFornecedorReducer"

export function EstrategiasFornecedorContextProvider({ children }: { children: React.ReactNode }) {
    const [dados, dispatch] = useReducer(estrategiasFornecedorReducer, EstrategiasFornecedorInicial)
    const [erroCarregamento, setErroCarregamento] = useState<string | null>(null)
    const setLoading = useLoadingStore(s => s.setLoading)

    const carregar = async () => {
        const autorizacao = localStorage.getItem("chaveSistema")
        if (!autorizacao) return
        try {
            setLoading(true)
            const response = await obterEstrategias(autorizacao)
            if ("retornoErro" in response) {
                setErroCarregamento(response.mensagem || "Erro ao carregar estratégias")
            } else {
                setErroCarregamento(null)
                dispatch({ type: EstrategiasFornecedorActionsTypes.CARREGAR, payload: response })
            }
        } catch {
            setErroCarregamento("Erro ao carregar estratégias")
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        carregar()
    }, [])

    return (
        <EstrategiasFornecedorContext.Provider value={{ dados, dispatch, erroCarregamento }}>
            <Loading />
            {children}
        </EstrategiasFornecedorContext.Provider>
    )
}
